<template>
  <div class="container page withdraw-page">
    <van-nav-bar :title="$t('my.withdraw')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#333" @click="back" />
      </template>
      <template #right>
        <span class="nav-right" @click="$router.push({ path: '/WithdrawRecord' })">
          {{ $t("withdraw.with_record") }}
        </span>
      </template>
    </van-nav-bar>

    <div class="page-body">
      <section class="account-card">
        <div class="info-row clickable" @click="openMethodSheet">
          <span class="info-label">{{ uiText.network }}</span>
          <span class="info-value">{{ currentMethodLabel || uiText.bindNow }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">{{ uiText.address }}</span>
          <span class="info-value">{{ currentAccountValue || uiText.bindNow }}</span>
        </div>
        <div class="info-row" v-if="currentStorageValue">
          <span class="info-label">{{ uiText.storage }}</span>
          <span class="info-value">{{ currentStorageValue }}</span>
        </div>
      </section>

      <section class="amount-card">
        <div class="amount-title">{{ uiText.withdrawAmount }}</div>
        <div class="amount-row">
          <van-field
            v-model="withdraw_money"
            type="digit"
            :placeholder="$t('my.msg47')"
          />
          <span class="all-text" @click="allMoeny">{{ uiText.all }}</span>
        </div>
      </section>

      <section class="password-card">
        <van-field
          v-model="paypassword"
          type="password"
          :placeholder="uiText.passwordPlaceholder"
        />
      </section>

      <div class="balance-text">
        {{ uiText.balance }}:
        <span>{{ userInfo.money || 0 }}</span>
      </div>

      <div class="withdraw-btn" @click="doWithdraw">{{ $t("withdraw.immediately_withdraw") }}</div>
    </div>

    <van-action-sheet
      v-model="showMethodSheet"
      :actions="methodActions"
      @select="selectMethod"
      close-on-click-action
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      withdraw_money: "",
      paypassword: "",
      type: "",
      userInfo: {},
      withdrawRole: {},
      bankInfo: {},
      showMethodSheet: false,
      guardPassed: false,
    };
  },
  computed: {
    uiText() {
      const lang = this.$t("auth.lang");
      const copy = {
        zh: {
          network: "选择网络",
          address: "地址",
          storage: "仓库",
          withdrawAmount: "提款金额",
          passwordPlaceholder: "请重新输入新的提现密码",
          balance: "当前余额",
          all: "全部",
          bindNow: "立即绑定",
          bank: "银行卡",
          usdt: "USDT-TRC20",
        },
        en: {
          network: "Network",
          address: "Address",
          storage: "Storage",
          withdrawAmount: "Withdrawal Amount",
          passwordPlaceholder: "Please enter withdrawal password",
          balance: "Current Balance",
          all: "All",
          bindNow: "Bind Now",
          bank: "Bank Card",
          usdt: "USDT-TRC20",
        },
        ja: {
          network: "ネットワーク",
          address: "アドレス",
          storage: "倉庫",
          withdrawAmount: "出金金額",
          passwordPlaceholder: "出金パスワードを入力してください",
          balance: "現在の残高",
          all: "すべて",
          bindNow: "今すぐ連携",
          bank: "銀行カード",
          usdt: "USDT-TRC20",
        },
        kr: {
          network: "네트워크",
          address: "주소",
          storage: "창고",
          withdrawAmount: "출금 금액",
          passwordPlaceholder: "출금 비밀번호를 입력해 주세요",
          balance: "현재 잔액",
          all: "전체",
          bindNow: "지금 연결",
          bank: "은행카드",
          usdt: "USDT-TRC20",
        },
      };

      return copy[lang] || copy.zh;
    },
    availableMethods() {
      const list = [];
      if (this.withdrawRole.bank && this.bankInfo.bankid) {
        list.push({ name: this.uiText.bank, type: 1 });
      }
      if (this.withdrawRole.usdt && this.bankInfo.usdt) {
        list.push({ name: this.bankInfo.network || this.uiText.usdt, type: 2 });
      }
      return list;
    },
    methodActions() {
      return this.availableMethods.map((item) => ({
        name: item.name,
        type: item.type,
      }));
    },
    currentMethodLabel() {
      const method = this.availableMethods.find((item) => item.type === this.type);
      return method ? method.name : "";
    },
    currentAccountValue() {
      if (this.type === 1) {
        return this.bankInfo.bankid || "";
      }
      if (this.type === 2) {
        return this.bankInfo.usdt || "";
      }
      return this.bankInfo.usdt || this.bankInfo.bankid || "";
    },
    currentStorageValue() {
      if (this.type === 2) {
        return this.bankInfo.warehouse || "";
      }
      return "";
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    isWithdrawBlocked() {
      return Number(this.userInfo.freeze_status || 0) !== 1;
    },
    openMethodSheet() {
      if (this.isWithdrawBlocked()) {
        this.$toast("Withdrawals from this account have been restricted");
        return;
      }
      if (this.availableMethods.length === 0) {
        this.$router.push({ path: "/BindUsdt" });
        return;
      }
      if (this.availableMethods.length === 1) {
        this.type = this.availableMethods[0].type;
        return;
      }
      this.showMethodSheet = true;
    },
    selectMethod(action) {
      this.type = action.type;
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.ensureWithdrawAccess();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserWithdrawRole() {
      this.$http({
        method: "get",
        url: "user_get_withdraw_role",
      }).then((res) => {
        if (res.code === 200) {
          this.withdrawRole = res.data || {};
          this.setDefaultMethod();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserBankInfo() {
      this.$http({
        method: "get",
        url: "user_get_bank",
      }).then((res) => {
        if (res.code === 200) {
          this.bankInfo = res.data.info || {};
          this.setDefaultMethod();
          this.ensureWithdrawAccess();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    ensureWithdrawAccess() {
      if (!Object.prototype.hasOwnProperty.call(this.userInfo, "paypassword")) {
        return;
      }

      if (!this.userInfo.paypassword) {
        this.$router.replace({ path: "/SetPayPassword", query: { redirect: "/Withdraw" } });
        return;
      }
      if (this.isWithdrawBlocked()) {
        this.$toast("Withdrawals from this account have been restricted");
        this.guardPassed = false;
        return;
      }

      if (!this.bankInfo.usdt && !this.bankInfo.bankid) {
        this.$router.replace({ path: "/BindUsdt", query: { redirect: "/Withdraw" } });
        return;
      }

      this.guardPassed = true;
    },
    setDefaultMethod() {
      if (this.type) {
        return;
      }
      if (this.withdrawRole.usdt && this.bankInfo.usdt) {
        this.type = 2;
        return;
      }
      if (this.withdrawRole.bank && this.bankInfo.bankid) {
        this.type = 1;
      }
    },
    allMoeny() {
      this.withdraw_money = this.userInfo.money;
    },
    doWithdraw() {
      if (!this.guardPassed) {
        this.ensureWithdrawAccess();
        return false;
      }
      if (this.isWithdrawBlocked()) {
        this.$toast("Withdrawals from this account have been restricted");
        return false;
      }
      if (!this.currentAccountValue) {
        this.$router.push({ path: "/BindUsdt" });
        this.$toast(this.$t("setting.set_bank"));
        return false;
      }
      if (this.withdraw_money <= 0) {
        this.$toast(this.$t("setting.correct_money"));
        return false;
      }
      if (this.paypassword === "") {
        this.$toast(this.$t("my.msg48"));
        return false;
      }
      if (this.type === "") {
        this.$toast(this.$t("my.msg49"));
        return false;
      }

      this.$http({
        method: "post",
        data: {
          money: this.withdraw_money,
          type: this.type,
          paypassword: this.paypassword,
        },
        url: "user_set_withdraw",
      }).then((res) => {
        if (res.code === 200) {
          this.$toast(res.msg);
          this.getUserInfo();
          this.withdraw_money = "";
          this.paypassword = "";
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
      return true;
    },
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
      this.getUserWithdrawRole();
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

.withdraw-page {
  min-height: 100vh;
  background: #fff;
}

.nav-bar {
  background: #fff;
}

.nav-bar ::v-deep .van-nav-bar__title,
.nav-bar ::v-deep .van-icon {
  color: #333;
}

.nav-right {
  font-size: 22px;
  color: #666;
}

.page-body {
  padding: 26px 14px 48px;
}

.account-card,
.amount-card,
.password-card {
  background: #fff;
}

.info-row {
  display: flex;
  align-items: center;
  min-height: 64px;
  font-size: 24px;
  color: #333;
}

.clickable {
  cursor: pointer;
}

.info-label {
  width: 116px;
  color: #666;
}

.info-value {
  flex: 1;
  color: #333;
  font-size: 24px;
  word-break: break-all;
}

.amount-card {
  margin-top: 30px;
  padding-bottom: 14px;
  border-bottom: 1px solid #efefef;
}

.amount-title {
  font-size: 28px;
  font-weight: 700;
  color: #222;
}

.amount-row {
  display: flex;
  align-items: flex-end;
  margin-top: 22px;
  border-bottom: 1px solid #f0f0f0;
}

.amount-row ::v-deep .van-cell {
  flex: 1;
  padding: 0 0 14px;
  background: transparent;
}

.amount-row ::v-deep input {
  font-size: 60px;
  line-height: 1.1;
}

.all-text {
  padding: 0 0 14px 16px;
  font-size: 26px;
  font-weight: 700;
  color: #d83a3a;
}

.password-card {
  margin-top: 20px;
  border-bottom: 1px solid #efefef;
}

.password-card ::v-deep .van-cell {
  padding: 22px 0;
  background: transparent;
}

.password-card ::v-deep input {
  font-size: 24px;
}

.balance-text {
  margin-top: 36px;
  font-size: 28px;
  font-weight: 700;
  color: #222;
}

.balance-text span {
  color: #d84e4e;
}

.withdraw-btn {
  margin-top: 38px;
  width: calc(100% - 50px);
  height: 80px;
  line-height: 80px;
  border-radius: 40px;
  background: #e89db7;
  font-size: 36px;
  font-weight: 700;
  text-align: center;
  color: #fff;
  margin-left: auto;
  margin-right: auto;
}
</style>
